import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function MyStory() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll();
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll();
  return <section id="my-story" className="bg-background overflow-hidden ![padding:0px_0px_96px_0px]">
      <div className="container mx-auto px-6 lg:px-8 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {}
          <div ref={textRef} className={cn("flex flex-col gap-8 transition-all duration-1000 ease-out transform", isTextVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10")}>
            <div className="space-y-4">
              <h2 className="text-4xl lg:text-5xl font-bold tracking-tight text-foreground font-sans">
                My Story
              </h2>
              <div className="h-1.5 w-24 bg-primary rounded-full" />
            </div>

            <div className="space-y-6 text-lg leading-[1.8] text-muted-foreground font-sans">
              <p>I am the only home inspector who is also a Government Building Inspector, a Carpenter and Architectural Designer. My journey started as a child, watching my family run their own construction business. <br /><br />At Fanshawe college I studied Construction Engineering Technology Management and went straight into site supervising for large public and civil projects throughout Grey-Bruce County. Including the Julie McArthur Regional Recreation Centre in Owen Sound and the Raw Water Intake Project for the Town of Saugeen Shores.</p>
              <p>I then started my 10 year career as a Municipal Building Inspector for the Town of Espanola, Town of Orangeville, and the Municipality of Georgian Bluffs. This experience turned me into an authority on the Ontario Building Code and the Building Code Act and member of the Ontario Building Officials Association (OBOA).</p>
              <p>Since 2023 I have been operating my own Design Build Construction Company. From here I create AutoCAD drawings for residential and commercial additions and renovations. I consult with homeowners who want to do the work themselves, and I arrange subcontractors and order materials for those who want a full general contractors service.</p>
              <p>Today, my mission is clear: to empower homeowners to believe that they can make the right decisions when it comes to their real estate needs. This isn't just about business—it's about helping homeowners turn their house into a home.</p>
            </div>

            <div className="flex flex-wrap gap-4 pt-4">
              <Button asChild size="lg" className="rounded-full px-8 text-base h-12">
                <Link to="/ContactPage">
                  Work With Me
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </Button>
            </div>

            {}
            
          </div>

          {}
          <div ref={imageRef} className={cn("relative transition-all duration-1000 ease-out delay-200 transform", isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10")}>
            {}
            <div className="absolute -inset-4 bg-gradient-to-tr from-primary/20 to-secondary/20 rounded-[2.5rem] blur-2xl -z-10 opacity-60" />
            
            {}
            <div className="relative rounded-2xl overflow-hidden shadow-2xl bg-card">
              
              
              {}
              <div className="absolute bottom-8 left-8 right-8 bg-background/95 backdrop-blur-md p-6 rounded-2xl shadow-lg border border-white/10">
                <p className="text-foreground font-medium italic text-lg">
                  "Success is not just about what you accomplish in your life, it's about what you inspire others to do with theirs."
                </p>
                <p className="text-primary font-bold mt-2">— Mike Dillard</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}